import { useTranslation } from "react-i18next";
import Footer from "@/pages/home/components/Footer";

/** Shown on pay.aistyle.com for any path that is not `/pay/{id}`. */
export default function PayHostFallback() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background-50">
      <main className="max-w-2xl mx-auto px-4 md:px-6 py-16 text-center">
        <h1 className="font-heading font-bold text-3xl text-foreground-950">
          {t("notFound.payHost.title")}
        </h1>
        <p className="mt-3 text-foreground-600">
          {t("notFound.payHost.body")}
        </p>
      </main>

      <Footer />
    </div>
  );
}
